import { Component, EventEmitter, Input, Output } from '@angular/core';
import Debug from 'debug';
import { localizationKeys } from '../../constants/localizationKeys';
import { AccountMappingEngine } from '../../mappers/account-mapping-engin';
export const debug = Debug('aumico:projet-reports:adjustments-reclasses-form.component');

@Component({
    selector: 'adjustments-reclasses-form-component',
    templateUrl: 'adjustments-reclasses-form.component.html',
    styleUrls: ['adjustments-reclasses-form.component.scss'],
})
export class AdjustmentsReclassesFormComponent {
    _engine: AccountMappingEngine;

    // The engine: can be balance engine or income engine
    @Input()
    public set engine(value: AccountMappingEngine) {
        debug('######### new set engine');
        this._engine = value;
        if (value != null) {
            this._engine.calculateAll();
            this.topGroups = this._engine.getTopGroups();
        } else {
            this.topGroups = [];
        }
    }

    topGroups = [];

    @Input()
    language = 'de_ch';
    @Input() defaultLanguage = 'de-ch';

    @Input()
    currency = 'CHF';

    @Input()
    isHideZeroFLIs = false;

    // refer to finNumber pipe for reference on values
    @Input()
    numberFormat = '1.2-2';

    @Input()
    wordBeforeCurrencyKey = localizationKeys.aumico_templates_reclass_label_in;
    @Input()
    totalWordKey = localizationKeys.aumico_templates_reclass_label_total;

    @Input() shouldRecalculate = false;

    /**
     * REV-XXXXX: forwarded to every nested group form so the reclass
     * cells render in read-only state for new-world reports. See
     * `isReclassNewWorld` in the consuming page.
     */
    @Input() readonlyReclasses = false;

    @Input()
    templateRowIdToRowChildrenIds: Map<string, string[]>;

    @Input() templateRowIdToParentsIds: Map<string, Set<string>>;

    @Output()
    copiedBalanceChangeInAdjustmentsToIncomeAdjustment: EventEmitter<number> = new EventEmitter<number>();

    copyBalanceChangeInAdjustmentToIncomeAdjustment(changeInAdjustmentValue: number) {
        this.copiedBalanceChangeInAdjustmentsToIncomeAdjustment.emit(changeInAdjustmentValue);
    }
}
